import Grid from '@mui/material/Unstable_Grid2/Grid2'
import { useEffect, useState } from 'react'
import OneSelect from '../OneSelect/OneSelect'
import OneButton from '../OneButton/OneButton'
import { CameraAltOutlined, CheckOutlined, ReplayOutlined } from '@mui/icons-material'
import FlipCameraIosOutlinedIcon from '@mui/icons-material/FlipCameraIosOutlined'
import { Box, Typography } from '@mui/material'
import WCam1 from "../../Assets/Imgs/plus_webcam_1.png"
import WCam2 from "../../Assets/Imgs/plus_webcam_2.png"
import WCam3 from "../../Assets/Imgs/plus_webcam_3.png"
import WCam4 from "../../Assets/Imgs/plus_webcam_4.png"
import WCam5 from "../../Assets/Imgs/plus_webcam_5.png"
import WCam6 from "../../Assets/Imgs/plus_webcam_6.png"
import { blackMask, mask, overlay } from './sxVideoCam'
import ImgCrop from '../ImgCrop/ImgCrop'

let MediaStream = null

const VideoCam = ({ close, setClose = () => {}, retornoFunc = () => {}, semMask = false, cropActive = false }) => {
    const [optionsCam, setOptionsCam] = useState([{ id: 0, descricao: 'Selecione' }])
    const [defaultCam, setDefaultCam] = useState()
    const [permissaoNegada, setPermissaoNegada] = useState()
    const [captura, setCaptura] = useState('')

    useEffect(() => {
        setDefaultCam(0)
        setPermissaoNegada(false)

        setTimeout(() => {
            document.getElementById("divBaterFoto").style.display = "flex"
            document.getElementById("divBateuFoto").style.display = "none"
        }, 100)

        start()

        setTimeout(() => {
            let objSession = sessionStorage.getItem("o_mo_camdevice_id")
            if (objSession) {
                // setDefaultCam(objSession)
            }
        }, 2000)
    }, [])

    useEffect(() => {
        if (!close) {
            StopVideo()
            setCaptura('')
        }
    }, [close])

    const handleSetCamera = async (event) => {
        if (event.target.value != undefined) {
            setDefaultCam(event.target.value)
            await startCamera(event.target.value)
        }
    }

    const toggleMirror = async () => {
        if (!MediaStream || !MediaStream.active) {
            return false
        }
        const newMirroredState = localStorage.getItem("cameraMirror") !== 'false'
        localStorage.setItem("cameraMirror", !newMirroredState)

        const video = document.getElementById("video")
        if (video) {
            video.style.transform = newMirroredState ? "scaleX(-1)" : "none"
        }

        startCamera()
    }

    async function startCamera(deviceId) {
        StopVideo()

        setTimeout(async () => {
            const constraints = {
                video: { facingMode: "user", deviceId: { exact: deviceId } }
            }
            const video = document.getElementById("video")
            const img = document.getElementById("img")

            img.style.display = "none"
            img.src = ""
            video.style.display = "flex"
            const mirrorState = localStorage.getItem("cameraMirror") !== 'false'
            video.style.transform = mirrorState ? "scaleX(-1)" : "none"

            document.getElementById("maskdiv").style.display = "flex"

            try {
                MediaStream = await navigator.mediaDevices.getUserMedia(constraints)
                video.srcObject = MediaStream
                sessionStorage.setItem("o_mo_camdevice_id", deviceId)
            } catch (error) {
                console.log('Error accessing media devices.', error)
            }
        }, 500)
    }

    const listDevices = async (mediaDevices) => {
        let cam_encontrada = false
        mediaDevices.forEach(mediaDevice => {
            let count = 1
            if (mediaDevice.kind === 'videoinput' && mediaDevice.deviceId != '') {
                cam_encontrada = true
                setOptionsCam(old => [...old, { id: mediaDevice.deviceId, descricao: (mediaDevice.label || `Camera ${count++}`) }])
            }
        })

        const ultCamSelecionada = sessionStorage.getItem("o_mo_camdevice_id")
        setTimeout(() => {
            handleSetCamera({ target: { value: ultCamSelecionada } })
        }, 100)

        if (!cam_encontrada) {
            PermissaoCameraNegada()
        }
    }

    const TakeSnapshot = () => {
        const video = document.getElementById("video")
        const canvas = document.createElement('canvas')

        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        canvas.id = "imagebase64"

        const context = canvas.getContext('2d')
        const isMirrored = localStorage.getItem("cameraMirror") !== 'false'
        if (isMirrored) {
            context.translate(canvas.width, 0)
            context.scale(-1, 1)
        }
        context.drawImage(video, 0, 0, canvas.width, canvas.height)
        const imageUrl = canvas.toDataURL('image/png')

        if (cropActive) {
            setCaptura(imageUrl)
        }
        const img = document.getElementById("img")
        img.src = imageUrl

        video.style.display = "none"
        img.style.display = "flex"

        document.getElementById("maskdiv").style.display = "none"
        document.getElementById("divBaterFoto").style.display = "none"
        document.getElementById("divBateuFoto").style.display = "flex"

        StopVideo()
    }

    const TirarFotoNovamente = () => {
        const video = document.getElementById("video")
        const img = document.getElementById("img")

        if (img == null && video == null) {
            startCamera()
            setCaptura('')
        } else {
            video.style.display = "flex"
            img.style.display = "none"
            img.src = null

            document.getElementById("divBaterFoto").style.display = "flex"
            document.getElementById("divBateuFoto").style.display = "none"
            startCamera()
        }
    }

    const Finalizar = (finalImage) => {
        const img = document.getElementById("img")

        if (img != null) {
            retornoFunc(img.src)
        } else {
            retornoFunc(finalImage)
        }
        StopVideo()
        setClose(false)
    }

    const start = async () => {
        const select = document.getElementById('cameraSelect')
        if (select) {
            select.innerHTML = ''
            const optionPadrao = document.createElement('option')
            optionPadrao.value = '0'
            optionPadrao.label = 'Selecione...'
            select.appendChild(optionPadrao)
        }
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            await navigator.mediaDevices.enumerateDevices()
                .then(listDevices)
                .catch(e => {
                    PermissaoCameraNegada()
                })
        } else {
            PermissaoCameraNegada()
        }

        // const ultCamSelecionada = sessionStorage.getItem("o_mo_camdevice_id")
        // // a2583a3a184004cc128c1c9cf57e176aaf00cc3f17dd4fd3a5a77144147ffe82
        // if (ultCamSelecionada) {
        //     setDefaultCam(ultCamSelecionada)
        // }
    }

    const StopVideo = () => {
        if (MediaStream) {
            const tracks = MediaStream.getTracks()
            tracks.forEach(track => track.stop())
            MediaStream = null
            document.getElementById('maskdiv').style.display = "none"
        }
    }

    const PermissaoCameraNegada = () => {
        setPermissaoNegada(true)
    }

    const InputsDisabled = () => {
        return permissaoNegada
    }

    const TutorialWebCam = () => {
        return (
            <>
                <Grid xs={12}>
                    <Typography sx={{ color: 'orange', fontSize: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}> Opa, estamos sem permissão para acessar sua câmera! </Typography>

                    <Typography sx={{ fontSize: '17px', display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', marginTop: '20px' }}> Se estiver usando o Chrome, tente seguir os passos abaixo: </Typography>

                    <Box sx={{ marginTop: '20px' }}>
                        <dl>
                            <dt>1 - Quando solicitado pelo navegador, aceite a permissão para acessar a câmera. <b>Caso essa janela não apareça, continue seguindo os passos abaixo</b></dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam1} /></dd>

                            <dt style={{ marginTop: '40px' }}>2 - Abra uma nova guia do Chrome (ctrl + T), cole esse link na guia de endereços e tecle enter: <b>chrome://flags/#unsafely-treat-insecure-origin-as-secure</b></dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam2} /></dd>

                            <dt style={{ marginTop: '40px' }}>3 - Na guia que se abre, adicione <b>{window.location.origin}</b> no campo <b>&quot;Insecure origins treated as secure&quot;</b>, e depois selecione <b>&quot;enable&quot;</b> no dropdown a direita, conforme exemplo abaixo:</dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam3} /></dd>

                            <dt style={{ marginTop: '40px' }}>4 - Feito isso, um botão <b>&quot;Relaunch&quot;</b> aparecerá na parte inferior direita da janela. Clique sobre o botão !. <b>Atenção: Seu navegador irá reiniciar</b></dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam4} style={{ maxWidth: '100%', height: 'auto' }}/></dd>

                            <dt style={{ marginTop: '40px' }}>5 - Agora, Clique sobre o icone ao lado da barra de navegação conforme imagem abaixo, e clique em &quot;Site Settings&quot; ou &quot;Configurações do site&quot;</dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam5} style={{ maxWidth: '100%', height: 'auto' }}/></dd>

                            <dt style={{ marginTop: '40px' }}>6 - Na janela em que se abre, procure por câmera e selecione &quot;Allow&quot; ou &quot;Permitir&quot; no dropdown, conforme imagem abaixo.</dt>
                            <dd style={{ marginTop: '10px' }}><img src={WCam6} style={{ maxWidth: '100%', height: 'auto' }}/></dd>

                            <dt style={{ marginTop: '20px', fontSize: '17px' }}><b>Feito isso, a câmera deve funcionar. Caso ainda esteja problemas, abra um chamado para o nosso suporte técnico!</b></dt>

                        </dl>
                    </Box>
                </Grid>
            </>
        )
    }

    const VideoEImgComp = ({ Mask }) => {
        return (
            <>
                <video style={{ width: '100%', maxWidth: '855px', height: '100%', maxHeight: '640px', border: '1px solid white', position: 'relative', MozTransform: "scaleX(-1)", Otransform: "scaleX(-1)", WebkitTransform: "scaleX(-1)", transform: "scaleX(-1)" }} id="video" autoPlay></video>
                <img style={{ width: '100%', maxWidth: '855px', height: '100%', maxHeight: '640px', position: 'relative', MozTransform: "scaleX(-1)", WebkitTransform: "scaleX(-1)", Otransform: "scaleX(-1)", transform: "scaleX(-1)" }} id="img"/>

                <div id="maskdiv" style={{ display: 'none' }}>
                    {!Mask && (
                        <Box sx={overlay}>
                            <Box sx={mask}></Box>
                            <Box sx={blackMask}></Box>
                        </Box>
                    )}
                </div>
            </>
        )
    }

    // const Maskk = useCallback(() => {
    //     return (
    //         <>
    //             {defaultMask == 1 &&
    //             <Box sx={overlay}>
    //                 <Box sx={mask}></Box>
    //                 <Box sx={blackMask}></Box>
    //             </Box>
    //             }
    //         </>
    //     )
    // }, [defaultMask])

    const WebCamPage = ({ semMaskara, captura }) => {
        return (
            <>
                <Grid xs={7} >
                    <Typography component="span">
                    Câmera:
                    </Typography>
                    <OneSelect
                        options={optionsCam}
                        value={defaultCam}
                        onChange={handleSetCamera}
                        disabled={InputsDisabled()}
                    />
                </Grid>

                <Grid xs={12} sx={{ marginTop: '20px' }}>
                    { captura
                        ? <Box width={'100%'}>
                            <ImgCrop imgSrc={captura} callbackFinalizar={Finalizar} callbackTirarFotoNovamente={TirarFotoNovamente}/>
                        </Box>
                        : <Box sx={{ position: 'relative' }}>
                            <VideoEImgComp Mask={semMaskara}/>
                        </Box>
                    }
                </Grid>

                <Grid xs={12} sx={{ display: "flex", justifyContent: 'center', paddingTop: '10px' }}>
                    <div id="divBaterFoto" style={{ display: captura ? "none" : "flex" }}>
                        <OneButton
                            variant="contained"
                            color="one_primary"
                            backgroundColor='true'
                            IconStart={CameraAltOutlined}
                            sxIconStart={{ width: '20px' }}
                            onClick={TakeSnapshot}
                        >
                        Tirar Foto
                        </OneButton>
                        <OneButton
                            variant="contained"
                            color="one_primary"
                            backgroundColor='true'
                            IconStart={FlipCameraIosOutlinedIcon}
                            sxIconStart={{ width: '20px' }}
                            onClick={toggleMirror}
                        >
                        Espelhar câmera
                        </OneButton>
                    </div>

                    <div id="divBateuFoto" style={{ display: "none" }}>
                        <OneButton
                            variant="contained"
                            color="one_primary"
                            backgroundColor='true'
                            IconStart={ReplayOutlined}
                            sxIconStart={{ width: '20px' }}
                            onClick={TirarFotoNovamente}
                        >
                        Tirar Nova Foto
                        </OneButton>

                        <OneButton
                            variant="contained"
                            color="success"
                            backgroundColor='true'
                            IconStart={CheckOutlined}
                            sxIconStart={{ width: '20px' }}
                            onClick={Finalizar}
                        >
                        Finalizar
                        </OneButton>
                    </div>

                </Grid>
            </>
        )
    }

    // ForcaNavegadorPedirPermissao()
    return (
        <Grid container xs={12} sx={{ gap: '5px' }}>
            <Grid xs={12} container sx={{ alignItems: 'center', width: '100%' }}>
                { !permissaoNegada &&
                    <WebCamPage semMaskara={semMask} captura={captura}/>
                }

                {permissaoNegada &&
                    <TutorialWebCam />
                }

            </Grid>
        </Grid>

    )
}

export default VideoCam
